const getters = {
    getBiayaWorkshopList: (state) => state.biayaWorkshopList,
    getBiayaWorkshopDetail: (state) => state.biayaWorkshopDetail,
    getPagination: (state) => state.pagination,
    getSearch: (state) => state.search,
    getIsSearch: (state) => state.isSearch,
    getQueryBiayaWorkshopList: (state) => state.queryBiayaWorkshopList,
    getScrollPosition: (state) => state.scrollPosition,
};

export default getters;
